<template>
	<div class="col-12 mb-3" v-show="moreThanZero">
		<div class="row justify-content-between align-items-center">
			<div class="col-auto">
				<h2 class="h4 mb-md-0">{{headerName}}</h2>
			</div>
			<div class="col-auto">
				<button class="btn btn-light" @click="browseBundles">Browse bundles</button>
			</div>
		</div>
	</div>
	<div v-for="(bundle, i) in _oBundles" class="col-sm-6 col-lg-3 mb-3 mb-md-4" :key="bundle.id">
		<a class="product-card card shadow-sm d-block text-decoration-none" :href="getUrl(bundle)">
			<div class="ratio ratio-3x2 rounded-top">
				<img :src="getPreviewImageUrl(bundle)" class="bg-image-top" :alt="getPreviewImageAlt(bundle)" :width="getImagePreviewWidth(bundle)" :height="getImagePreviewHeight(bundle)" loading="lazy" />
			</div>
			<div class="card-body p-md-4">
				<h3 class="product-card-title h6 text-black">
					<span>{{bundle.name}}</span>
				</h3>
				<div class="product-card-actions d-flex align-items-center justify-content-between">
					<div class="badges">
						<div class="badge sale" v-if="isDiscounted(bundle)">SALE</div>
						<div class="badge" :class="clsBadgeCredits(bundle)">
							<!--<i class="icon-coins me-1"></i>-->
							<span><!--&nbsp;-->{{toDollarAmount(bundle.actualNrCredits)}}</span>
						</div>
					</div>
					<timer :seconds="getDiscountNrSeconds(bundle)" @ended="timerEnded(bundle)" v-if="isDiscounted(bundle)"></timer>
				</div>
			</div>
		</a>
	</div>
</template>




<script>
	import timer from './Timer.vue';
	import { versionedImageUrl } from '@/js/shared/utils/common';
	import { toNrDecimals } from '@/js/shared/utils';

	export default {
		components: {
			timer
		},
		data: () => ({
			_oBundles : {}
		}),
		props: {
			headerName : { type: String, required: false, default: () => ('Bundles')},
			buttonUrl : { type: String, required: false, default: () => ('/bundles/')},
			oBundles: { type: Array, required: false, default: () => ([])},
		},
		created() {
			this._oBundles = this.oBundles;
		},
		mounted() {
		},
		methods: {
			browseBundles() {
				window.open(this.buttonUrl, '_blank');
			},
			getUrl(bundle) {
				return bundle?.url;
			},
			getFirstImage(bundle) {
				return bundle?.images?.[0];
			},
			getPreviewImageUrl(bundle) {
				var image = this.getFirstImage(bundle);
				return versionedImageUrl(image?.img500Url, image?.imgOriSha1);
			},
			getPreviewImageAlt(bundle) {
				return bundle?.name;
			},
			getImagePreviewWidth(bundle) {
				var image = this.getFirstImage(bundle);
				return image?.img500Width ?? 0;
			},
			getImagePreviewHeight(bundle) {
				var image = this.getFirstImage(bundle);
				return image?.img500Height ?? 0;
			},
			getDiscountNrSeconds(bundle) {
				return bundle?.discountPeriods?.[0]?.endsInNrSeconds ?? 0;
			},
			isDiscounted(bundle) {
				return (bundle?.discountPeriods?.length > 0);
			},
			clsBadgeCredits(bundle) {
				let discounted = this.isDiscounted(bundle);

				return {
					'regular-price' : !discounted,
					'discount-price' : discounted
				};
			},
			timerEnded(bundle) {
				bundle.discountPeriods = [];
			},
			toDollarAmount(nrCredits) {
				return `$${toNrDecimals(nrCredits, 2, 2)}`;
			}
		},
		computed: {
			moreThanZero() {
				return (this._oBundles.length > 0);
			}
		},
		watch: {
		}
	};
</script>




<style scoped>@import '../../scss/common/parts/Button.scss'</style>
<style scoped>@import '../../scss/common/parts/Extra.scss'</style>
<style scoped>@import '../../scss/common/parts/Override.scss'</style>

<style scoped>
	[v-cloak] {
		display:none;
	}

	.accordion-body p:last-child {
		margin-bottom: 0;
	}

	table, th, td {
		border:2px solid rgb(67, 56, 202);
		border-collapse:collapse;
		padding:10px 20px;
	}

	:deep(.timer-container) {
		color: #13795b;
		font-weight: 600;
	}
</style>
